<template>
  <div class="filters-list" :class="{ 'filters-list--is-active': isActive }">
    <div class="filters-list__bg" @click="$emit('click')"/>
    <ul
      class="filters-list__inner"
      :class="{ 'filters-list__inner--is-active': isActive }"
    >
      <li
        v-for="(filter, i) in availableFilters"
        :key="i"
        class="filters-list__item"
      >
        <button
          class="filters-list__btn"
          :class="{ 'filters-list__btn--is-active': isFilterActive(filter) }"
          @click.stop="$emit('toggleFilter', filter)"
        >
          {{ filter }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    availableFilters: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Array,
      default: () => []
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isFilterActive () {
      return filter => this.filters.find(item => item === filter)
    }
  }
}
</script>

<style lang="scss" scoped>
  .filters-list {
    @include hide-down(md);

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100vh;
    z-index: z(filters-button) - 1;

    pointer-events: none;

    &--is-active {
      pointer-events: auto;
    }

    &__bg {
      @include full-size(fixed);
    }

    &__inner {
      @include reset-list;

      position: relative;
      z-index: 1;

      width: 100%;
      background-color: #fff;
      text-align: center;
      overflow: hidden;

      padding: 100px 0 10px;

      @include media-up(xl) {
        padding: 140px 0 20px;
      }

      pointer-events: none;
      transform: translate3d(0, -100%, 0);
      transition: transform .35s ease,
                  box-shadow .35s ease;
    }

    &__inner--is-active {
      pointer-events: auto;
      transform: translate3d(0, 0, 0);
      box-shadow: 0px 8px 27.26px 1.74px rgba(0, 0, 0, 0.23);
    }

    &__item {
      margin: 20px 0;

      @include media-up(xl) {
        margin: 30px 0;
      }

      opacity: 0;
      transform: translate3d(0, -16px, 0);
      transition: opacity .15s ease-in-out,
                  transform .15s ease-in-out;
    }

    &__inner--is-active &__item {
      opacity: 1;
      transform: translate3d(0, 0, 0);
      transition: opacity .3s ease-in-out .2s,
                  transform .3s ease-in-out .2s;
    }

    &__btn {
      @include reset-button;
      @include uppercase-text;
      color: $base-opposite-color;

      transition: color $base-transition,
                  opacity $base-transition;

      &--is-active {
        color: $accent-color;
      }

      &:hover {
        opacity: .8;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Filters/FiltersList.vue